// @flow
import Immutable from "seamless-immutable";
import { defaults } from "uploader";

type UIParams = {
    sources?: string[],
    searchBySites?: any,
    cloudName: string,
    inlineMode: boolean,
    defaultSource: ?string,
    multiple: boolean,
    googleApiKey: ?string,
    googleDriveClientId: ?string,
    dropboxAppKey: ?string,
    facebookAppId: ?string,
    instagramClientId: ?string,
    searchByRights: boolean,
    autoMinimize: boolean,
    useTagsCallback: boolean,
    useUploadPresetsCallback: boolean,
    text: ?Object,
    language: string,
    maxFiles: number,
    showAdvancedOptions: boolean,
    showPoweredBy: boolean,
    showCompletedButton: boolean,
    showUploadMoreButton: boolean,
    cropping: boolean,
    croppingAspectRatio: number,
    croppingDefaultSelectionRatio: number,
    croppingShowDimensions: boolean,
    croppingCoordinatesMode: string,
    croppingShowBackButton: boolean,
    minImageWidth: number,
    minImageHeight: number,
    theme: string,
    singleUploadAutoClose: boolean,
    maxFileSize: number,
    maxImageFileSize: number,
    maxVideoFileSize: number,
    maxRawFileSize: number,
    showSkipCropButton: boolean,
    shutterstockServer: string,
    istockServer: string,
    gettyServer: string,
};

const uiConfigKeys = [ // the params UI cares about
	"cloudName",
	"inlineMode",
	"sources",
	"defaultSource",
	"multiple",
	"googleApiKey",
	"googleDriveClientId",
	"dropboxAppKey",
	"facebookAppId",
	"instagramServer",
	"searchBySites",
	"searchByRights",
	"autoMinimize",
	"useTagsCallback",
	"useUploadPresetsCallback",
	"text",
	"language",
	"maxFiles",
	"showAdvancedOptions",
	"showPoweredBy",
	"showCompletedButton",
	"showUploadMoreButton",
	"cropping",
	"croppingAspectRatio",
	"croppingDefaultSelectionRatio",
	"croppingShowDimensions",
	"croppingCoordinatesMode",
	"croppingShowBackButton",
	"minImageWidth",
	"minImageHeight",
	"maxImageWidth",
	"maxImageHeight",
	"theme",
	"singleUploadAutoClose",
	"maxFileSize",
	"maxImageFileSize",
	"maxVideoFileSize",
	"maxRawFileSize",
	"showSkipCropButton",
	"shutterstockServer",
	"istockServer",
	"gettyServer",
	"clientAllowedFormats",
	"tabInsideWidget",
	"newTlsDomain"
];

export const takeUiParams = (data: Object): UIParams => Object.keys(data)
	.filter((key) => ~uiConfigKeys.indexOf(key)) // only leave the relevant ui params
	.reduce((res, key) => {
		res[key] = data[key];
		return res;
	}, {});

export default () => Immutable({
	...takeUiParams(defaults),
	__record: "WidgetConfigRecord",
});
